import { useState } from 'react';
import { asyncGetPqrs } from '../../../../../../services/pqr.service';
import { Account } from '../../../../../../shared/types/modules/account';
import { Pqr } from '../../../../../../shared/types/modules/pqr';
import { ParamEnum } from '../../../../../../shared/types/shared';
import { GridPaginationModel } from '@mui/x-data-grid';

export const useCasePqr = (account?: Account) => {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<Pqr[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);

    const [accountHasRecentPqr, setAccountHasRecentPqr] = useState(false);
    const [hasExpandedOnce, setHasExpandedOnce] = useState(false);

    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };

    const handleAccordionChange = () => {
        if (!hasExpandedOnce) {
            setHasExpandedOnce(true);
            setLoading(true);
            const oneMonthAgo = new Date();
            oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
            const statusFilter = [
                `${ParamEnum.PQR_STATUS}_ABI`,
                `${ParamEnum.PQR_STATUS}_TRA`,
                `${ParamEnum.PQR_STATUS}_AMP`,
                `${ParamEnum.PQR_STATUS}_REC`,
                `${ParamEnum.PQR_STATUS}_SOL`,
                `${ParamEnum.PQR_STATUS}_SEG`,
                `${ParamEnum.PQR_STATUS}_PRO`,
            ];

            asyncGetPqrs({
                document: account?.document,
                name: account?.name,
                startCreatedAt: oneMonthAgo,
                status: statusFilter,
            })
                .then(async (res) => {
                    setAccountHasRecentPqr(res.items.length > 0);
                    setRows(res.items);
                    setTotal(res.length);
                })
                .finally(() => setLoading(false));
        }
    };

    return {
        loading,
        rows,
        total,
        page,
        pageSize,
        paginator,
        accountHasRecentPqr,
        setAccountHasRecentPqr,
        handleAccordionChange,
    };
};
